import {
  LuArrowLeft,
  LuCheck,
  LuChevronsLeft,
  LuCircleAlert,
  LuCircleCheck,
  LuEye,
  LuEyeOff,
  LuFolder,
  LuLayoutDashboard,
  LuLayers,
  LuList,
  LuLoaderCircle,
  LuLock,
  LuLogOut,
  LuMail,
  LuMenu,
  LuPackage,
  LuPencil,
  LuPlus,
  LuSave,
  LuSearch,
  LuShield,
  LuTrash2,
  LuUsers,
  LuX,
} from "react-icons/lu";

const spinClass = "admin-icon-spin";

export const IconSpinner = ({ size = 28, className = "" }) => (
  <LuLoaderCircle size={size} className={`${spinClass} ${className}`.trim()} />
);

export {
  LuArrowLeft as IconArrowLeft,
  LuCheck as IconCheck,
  LuChevronsLeft as IconChevronsLeft,
  LuCircleAlert as IconCircleAlert,
  LuCircleCheck as IconCircleCheck,
  LuEye as IconEye,
  LuEyeOff as IconEyeOff,
  LuFolder as IconFolder,
  LuLayoutDashboard as IconLayoutDashboard,
  LuLayers as IconLayers,
  LuList as IconList,
  LuLock as IconLock,
  LuLogOut as IconLogOut,
  LuMail as IconMail,
  LuPackage as IconPackage,
  LuMenu as IconMenu,
  LuPencil as IconPencil,
  LuPlus as IconPlus,
  LuSave as IconSave,
  LuSearch as IconSearch,
  LuShield as IconShield,
  LuTrash2 as IconTrash,
  LuUsers as IconUsers,
  LuX as IconX,
};
